import style from "./appModePage.module.scss";
import AccountHeader from "../../components/AppAccount/AccountHeader";
import { clearFavourites, getFavourites, saveFavourite } from "../../components/FavouriteButton/favouritesService";
import Favourite from "../../components/AppAccount/Favourite";
import { useState } from "react";
import Dialog from "./Dialog";

const FavouritesPage = () => {
  const [favourites, setFavourite] = useState(getFavourites());
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const removeFavourite = (title, url, type, guideline) => {
    saveFavourite(title, url, type, guideline);
    setFavourite([...getFavourites()]);
  }

  const clearAllFavourites = () => {
    clearFavourites();
    setFavourite([...getFavourites()]);
    setConfirmDialogOpen(false);
  }

  return (
    <div className={style.accountContainer}>
      <AccountHeader headername="My favourites" />
      <button
        className={style.clearAllButton}
        onClick={() => setConfirmDialogOpen(true)}
      >
        Clear all
      </button>
      {favourites.map((favourite, index) => (
        <Favourite
          title={favourite.favouriteTitle}
          url={favourite.favouriteUrl}
          guideline={favourite.topicSection?.replace("/", "")}
          type={favourite.type}
          removeFavourite={removeFavourite}
          key={`favId-${index}`}
        ></Favourite>
      ))}
      <Dialog
        bodyText="Are you sure you want to clear all items from your Favourites list? This action cannot be undone."
        confirmFunction={clearAllFavourites}
        heading="Confirmation"
        buttonText="Clear all"
        isOpen={confirmDialogOpen}
        setIsOpen={setConfirmDialogOpen}
      ></Dialog>
    </div>
  );
};

export default FavouritesPage;
